'use client';

import Image from 'next/image';
import React, { ReactNode } from 'react';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';

export interface ProposalListBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  content: ReactNode | SerializedEditorState;
  image: string | { url: string; alt: string };
}

export default function TxtWithImageBlock({ title, content, image, id }: ProposalListBlockProps) {
  return (
    <div
      id={id}
      data-meta="TxtWithImageBlock"
      className="container max-w-7xl mx-auto my-14 overflow-hidden"
    >
      <div className="px-4 py-5 sm:px-6 flex justify-center">
        <CustomRichText
          data={title}
          tag="div"
          className="text-4xl xl:text-6xl mb-4 xl:mb-8 font-bold text-center text-white"
        />
      </div>
      <div className="mb-8 bg-white rounded-[2rem] overflow-hidden flex flex-col justify-center md:grid md:grid-cols-12 md:gap-4 gap-2">
        <div className="flex flex-col md:col-span-6 lg:col-span-6 justify-between p-8">
          <CustomRichText data={content} tag="div" className="max-lg:text-xs" />
          <div className="flex mt-8 md:mt-0 gap-2 justify-between">
            <Image src={'/assets/icon/LanguageCert.svg'} alt={''} width={150} height={100} />
            <Image src={'/assets/icon/CambridgeLong.svg'} alt={''} width={250} height={150} />
          </div>
        </div>
        <Image
          alt={''}
          src={typeof image === 'string' ? image : image?.url}
          sizes="auto"
          width={780}
          height={550}
          style={{
            width: '100%',
            height: 'auto',
          }}
          className="md:col-span-6 object-contain lg:translate-x-4"
        />
      </div>
    </div>
  );
}
